export class AmbassadorLoginDTO
{
    IdAmbassador: string;
    User: string;        
    OtpCode: string;        
}